<template>
    <div class="page-view">
      <div class="kategorija-form">
        <ejs-textbox v-model="webID" floatLabelType="Auto" placeholder="Web ID*" width="100%"></ejs-textbox>
        <ejs-textbox v-model="Name" floatLabelType="Auto" placeholder="Naziv*" width="100%"></ejs-textbox>
        <ejs-textbox v-model="Prio" floatLabelType="Auto" placeholder="Poredak*" width="100%"></ejs-textbox>
        <p v-if="this.saveDisabled" style="text-align: center;">Popunite obavezna polja (*)</p>
        <ejs-button class=save-btn v-on:click.native='onSpremi' :disabled="this.saveDisabled">SPREMI</ejs-button>
      </div>
    </div>
</template>

<style lang="scss">
.kategorija-form {
  width: 80%;
  margin: 0 auto 0 auto;
}
</style>

<script>
export default {
  name: 'categories_info',
  data() {
    return {
      isEditMode: false,

      webID: undefined,
      Name: undefined,
      Prio: undefined,
    }
  },
  mounted() {
    this.$store.state.hideCloseIcon = false;
    this.$store.state.hideReturnIcon = true;
    this.$store.state.hideSettingIcon = true;
    this.$store.state.hideFloatWidgetRight = true;
    this.$store.state.currentView = 'kategorija';
    this.$store.state.previousView = 'kategorije';
    if (this.$store.state.selectedCategory) {
      this.isEditMode = true;
      this.$store.state.viewTitle = 'Uredi kategoriju';
      this.loadEditData();
    } else {
      this.$store.state.viewTitle = 'Nova kategorija';
    }
  },
  methods: {
    onSpremi() {
      const payload = {
        webID: this.webID,
        Name: this.Name,
        Prio: this.Prio,
      };

      if (this.isEditMode === false) {
          this.$store.dispatch('insertCategories', payload).then(res => {
            this.$parent.showNotification(res);
            this.$router.push(this.$store.state.previousView);
            })
            .catch(err => this.$parent.showNotification(err));
      } else {
          payload.ID = this.$store.state.selectedCategory.ID;
          this.$store.dispatch('updateCategories', payload).then(res => 
          {
            this.$parent.showNotification(res);
            this.$router.push(this.$store.state.previousView);
          })
          .catch(err => this.$parent.showNotification(err));
      }
    },
    loadEditData() {
      this.webID = this.getCategoryValue('webID');
      this.Name = this.getCategoryValue('Name');
      this.Prio = this.getCategoryValue('Prio');
    },
    getCategoryValue(key) {
      if (this.$store.state.selectedCategory) return this.$store.state.selectedCategory[key] || undefined;
      return undefined;
    },
  },
  computed: {
    saveDisabled() {
      if (this.webID && this.Name && this.Prio) return false;
      return true;
    }
  }
}
</script>